import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18nInit } from './i18nInit-browser';
import { useConfigContext } from '../config-context';
export var TranslationsProvider = function (_a) {
    var children = _a.children;
    var configContext = useConfigContext();
    if (configContext.i18n) {
        return children;
    }
    return (React.createElement(I18nextProvider, { i18n: i18nInit(configContext.locale) }, children));
};
//# sourceMappingURL=translations-provider.js.map